export default function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="privacy-page">
      <div className="overline" style={{ color: "var(--terracotta)" }}>Legal</div>
      <h1 className="font-serif text-5xl mt-2">Privacy Policy</h1>
      <p className="mt-3 text-xs" style={{ color: "var(--ink-soft)" }}>Last updated: {new Date().toLocaleDateString()}</p>

      <div className="mt-10 space-y-8 text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>
        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>1. What we collect</h2>
          <ul className="mt-2 list-disc pl-6 space-y-1">
            <li>Account info: name, email, hashed password, role (maker or host), business name.</li>
            <li>Profile content: bio, categories, portfolio images, website, location.</li>
            <li>Application content: pitches, product descriptions, event listings.</li>
            <li>Payment metadata (never full card numbers) via Stripe.</li>
            <li>Basic server logs (IP, user-agent, timestamps) for security and abuse prevention.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>2. How we use it</h2>
          <p className="mt-2">
            To operate the marketplace: create your account, show your public vendor page, deliver applications to
            organizers, process signup and booth fees, and prevent abuse. We do not sell your personal data.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>3. Sharing</h2>
          <p className="mt-2">
            Your public vendor page (name, bio, portfolio) is visible to anyone with the link. Your applications are
            visible to the event&apos;s organizer. Payment is handled by Stripe under their privacy policy.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>4. Cookies</h2>
          <p className="mt-2">
            We use HTTP-only session cookies for authentication. We do not use third-party advertising cookies.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>5. Your rights</h2>
          <p className="mt-2">
            You can edit your profile any time. You can request account deletion by emailing us; we&apos;ll remove your
            personal data within 30 days except where retention is legally required.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>6. Contact</h2>
          <p className="mt-2">
            Privacy questions? Email <a className="underline" href="mailto:privacy@addvendtour.com">privacy@addvendtour.com</a>.
          </p>
        </section>

        <p className="text-xs italic pt-8" style={{ color: "var(--ink-soft)" }}>
          This document is a plain-language starting point and is not a substitute for legal advice.
          Please have counsel review before public launch.
        </p>
      </div>
    </div>
  );
}
